// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__19uv9","rootSmall":"AddTileButton_rootSmall__3xR9C"};